import styled, { css } from 'styled-components';
import { ANIMATION_CURVE, ANIMATION_DURATION, Disableable, getSpacingToken, getToken } from '@optimus-web/common';
import { Icon } from '../Icon';
import { Typography } from '../typography';
import {
    getActiveBackgroundColor,
    getActiveBorderColor,
    getActiveColor,
    getBackgroundColor,
    getBorderColor,
    getColor,
    getHoverBackgroundColor,
    getHoverBorderColor,
    getHoverColor,
} from './getFilterChipStyles';

const COLOR_TRANSITION = css`
    transition-property: background-color, border-color, color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
`;

export const FilterChipButton = styled.button<Disableable & { active?: boolean; size?: 'small' | 'medium' }>`
    display: inline-flex;
    padding: ${getSpacingToken('100')}px;
    gap: ${getSpacingToken('50')}px;
    background-color: ${getBackgroundColor};
    border-radius: ${getToken('borderRadius100')}px;
    align-items: center;
    overflow: hidden;
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
    height: ${getToken('sizing400')}px;
    border: ${getToken('borderWidth100')}px solid ${getBorderColor};
    width: auto;
    max-width: 100%;
    ${(props) =>
        props.size !== 'small' &&
        css`
            height: ${getToken('sizing500')}px;
            padding: ${getSpacingToken('150')}px;
        `}
    &:hover {
        background-color: ${getHoverBackgroundColor};
        border-color: ${getHoverBorderColor};
    }

    &:active {
        background-color: ${getActiveBackgroundColor};
        border-color: ${getActiveBorderColor};
    }
    ${COLOR_TRANSITION};
`;

export const FilterChipText = styled(Typography)<Disableable & { ellipsis?: boolean }>`
    color: ${getColor};
    ${COLOR_TRANSITION};
    white-space: nowrap;
    ${(props) =>
        props.ellipsis &&
        css`
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        `}
`;

export const FilterChipIconButton = styled(Icon)<Disableable>`
    color: ${getColor};
    &:hover:enabled {
        color: ${getHoverColor};
    }
    &:active:enabled {
        color: ${getActiveColor};
    }
    ${COLOR_TRANSITION};
`;
